// extracted by mini-css-extract-plugin
export default {"chartContainerfii":"Fiidii_chartContainerfii__Plvmu","chartTitle":"Fiidii_chartTitle__gbYDj"};